import { store } from "common/store";

export const findLastInHistoryStack = (predicate = () => true) => {
    const stack = [...store.getState().common.historyStack];
    let fragment = null;

    while (stack.length) {
        const route = stack.pop();
    
        // Short-circuits and stops traversing the list if a true element is found.
        if (predicate(route, stack.length)) {
            fragment = route;
            break;
        }
    }
    return fragment;
};
